export const getActivities = (state) => state.activity?.activities;